document.addEventListener("alpine:init", () => { 
    Alpine.data("podcastModal", () => ({
      open: false,
  
      handleModalOpen() {
        this.open = true;
        document.body.classList.add("modal-open");
        this.$nextTick(() => {
          this.$dispatch("modalopen");
        });
      },
  
      handleModalClose() {
        document.body.classList.remove("modal-open");
        this.open = false;
      }
    }));
});